import {useIdentityAuth} from "../context/IdentityAuthContext";
import {getApiErrorMessage} from "../utils/apiError";
import {snackbar} from "../utils/snackbar";

const useLogout = () => {
  const {logout: identityLogout} = useIdentityAuth();

  const logout = async () => {
    try {
      // Limpia tokens internos de Identity y cierra sesión en Teamsystem.
      await identityLogout();
      return {success: true};
    } catch (error) {
      snackbar.error(getApiErrorMessage(error, "No se ha podido cerrar la sesión."));
      return {success: false, error};
    }
  };

  const logoutWithConfirmation = (message = "¿Estás seguro de que quieres cerrar sesión?") => {
    if (window.confirm(message)) {
      return logout();
    }
    return {success: false, cancelled: true};
  };

  return {
    logout,
    logoutWithConfirmation
  };
};

export default useLogout;
